
import {
  computed,
  defineComponent,
  ref,
} from 'vue'

export default defineComponent({
  name: 'VueCollapsibleCard',
  props: {
    swapped: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'from-bottom',
    },
    event: {
      type: String,
      default: 'over',
    },
  },
  setup(props) {
    const eventSwapped = ref(props.swapped)

    const isSwapped = computed(() => props.swapped || eventSwapped.value)

    const swapDirection = computed(() => {
      const validDirections = ['from-top', 'from-right', 'from-bottom', 'from-left']

      return validDirections.includes(props.direction) ? props.direction : validDirections[0]
    })

    const classList = computed(() => ({
      'vsc--swapped': isSwapped.value,
      [`vsc--${swapDirection.value}`]: true,
    }))

    const swapEvent = computed(() => {
      const validEvents = ['over', 'click']

      return validEvents.includes(props.event) ? props.event : validEvents[0]
    })

    const eventList = computed(() => ({
      mouseenter: swapEvent.value === 'over' ? swap : false,
      mouseleave: swapEvent.value === 'over' ? swap : false,
      click: swapEvent.value === 'click' ? swap : false,
    }))

    const swap = () => {
      eventSwapped.value = !eventSwapped.value
    }

    return {
      classList,
      eventList,
    }
  },
})
